import { NEBULY_PAGE_KEYS, NEBULY_PAGE_ROUTES } from '@/domains/pages/constants';
import type { ReportSubproduct } from '@/domains/reports/utils/report-subproduct.utils';
import type { NebulyPageDefinition, NebulyPageKey } from '@/domains/pages/types';
import { getNebulyPageDefinition } from '@/domains/pages/registry';

export function getNebulyPageSubproduct(page: Pick<NebulyPageDefinition, 'subproduct'>): ReportSubproduct {
  return page.subproduct;
}

export function getNebulyPageSubproductByKey(pageKey: NebulyPageKey): ReportSubproduct {
  return getNebulyPageSubproduct(getNebulyPageDefinition(pageKey));
}

export function getNebulyPageSubproductForPathname(pathname: string): ReportSubproduct | null {
  for (const pageKey of NEBULY_PAGE_KEYS) {
    const route = NEBULY_PAGE_ROUTES[pageKey];
    if (pathname === route || pathname.startsWith(`${route}/`)) {
      return getNebulyPageSubproductByKey(pageKey);
    }
  }
  return null;
}
